import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Modal,
  Pagination,
  Section,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import React, { useState } from "react";
import { useSelector } from "react-redux";
import {getPartLookupData, getPartsData} from "../../state/selectors";
import { usePartsData } from "../../hooks/usePartsData";
import { readableDate } from "../../utils";
import {usePartLookupData} from "../../hooks/usePartLookupData";
import PaginationWrapper from "../Utils/PaginationWrapper";

export default function PartSearchModal({
  modalOpen,
  currentSearch,
  searchText,
  selectPart,
  partIndex,
  setModalState,
  workIndex
}) {
  const [page, setPage] = useState(1);
  let params = {
    page: page,
    search: currentSearch,
    view: "with_number",
    part_lookup_stock: true
  };

  const complete = usePartLookupData(params, 1, !modalOpen);
  const data = useSelector(getPartLookupData);

  const setModalOpen = val => {
    setModalState({
      modalOpen: val,
      currentSearch,
      searchText,
      partIndex,
      workIndex
    });
  };

  const setSearchText = val => {
    setModalState({
      searchText: val,
      currentSearch,
      modalOpen,
      partIndex,
      workIndex
    });
  };

  const setCurrentSearch = val => {
    setModalState({
      currentSearch: val,
      searchText,
      modalOpen,
      partIndex,
      workIndex
    });
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <Modal closeOnBlur active={modalOpen} onClose={() => setModalOpen(false)}>
      <Modal.Content className="part-search-content">
        <Section style={{ backgroundColor: "grey" }}>
          <Box>
            <Title>Parts Selector</Title>
            <Columns isMultiline>
              <Column>
                <label className="label">Part Search</label>
                <Field className="has-addons">
                  <Control>
                    <Input
                      onChange={e => {
                        setSearchText(e.target.value);
                      }}
                      onKeyPress={e => (e.key === 'Enter' || e.keyCode === 13) && setCurrentSearch(searchText)}
                      data-testid="part-search"
                      name="search_text"
                      type="text"
                      placeholder="Search"
                      value={searchText}
                    />
                  </Control>
                  <Control>
                    <Button
                      data-testid="search-button"
                      color="success"
                      onClick={() => {
                        setCurrentSearch(searchText);
                      }}
                    >
                      Search
                    </Button>
                  </Control>
                  <Control>
                    <Button
                      color="warning"
                      onClick={() => {
                        setModalState({
                          modalOpen,
                          partIndex,
                          workIndex,
                          currentSearch: "",
                          searchText: ""
                        });
                      }}
                    >
                      Clear
                    </Button>
                  </Control>
                </Field>
              </Column>
            </Columns>
          </Box>
          <Box>
            <Table>
              <thead>
                <tr>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Vehicle Type</th>
                  <th>Part Name</th>
                  <th>Part Number</th>
                  <th>Part Cost</th>
                  <th>Part Customer Charge</th>
                  <th>Supplier</th>
                  <th>Stock Volume</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {complete &&
                  data &&
                  data.results.map(part => (
                    <tr key={part.id}>
                      <td>{part.make ? part.make.name : ""}</td>
                      <td>{part.model ? part.model.name : ""}</td>
                      <td>
                        {part.vehicle_type
                          ? part.vehicle_type.name
                          : ""}
                      </td>
                      <td>{part.name}</td>
                      <td>{part.part_number}</td>
                      <td>
                        £
                        {(part.cost || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                      <td>
                        £
                        {(part.customer_cost || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </td>
                      <td>{part.supplier && part.supplier.display_name}</td>
                      <td>{part.stock_volume}</td>
                      <td>
                        <Button
                          onClick={() => {
                              selectPart(part, partIndex, workIndex);
                              setPage(1);
                            }
                          }
                          color="success"
                        >
                          Select
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Columns>
              <Column>
                <Button
                  color={"info"}
                  onClick={() => setModalOpen(false)}
                >
                  Close
                </Button>
              </Column>
            </Columns>
            <PaginationWrapper
              setPage={setPage}
              page={page}
              dataCount={Math.ceil(data.count / 25)}
            />
          </Box>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
